/**
 * Sample page JS provided here for extension. Might not be useful if all JS is based on components.
 */
 class IconCta extends DrupalBehavior {

  onContent(context) {
    // Initialize javascript.
  }

  onReady(document) {
    const adjustCtaIcons = () => {
      const $hero = $('.hero');
      const $el = $hero.find('.cta-icon.cta-icon--floating-box').first();

      // NOTE: `($hero && $el)` is giving a false positive and so `.outerHeight()` was giving `NAN`, causing layout issues.
      // TODO: Replace `($hero && $el)` with  `($hero.length > 0 $el.length > 0)` and adjust .blurb which is relying on the false positive for `bottom` inline styling.
      if ($hero && $el) {
        const $blurb = $hero.find('.blurb');
        var blurbBottom = 0;
        var heroMargin = 0;
        if (window.innerWidth > 768) {
          // TODO: Remove `if ($el.length > 0)` once the above TODO is fixed.
          if ($el.length > 0) {
            blurbBottom = `-${$el.outerHeight() - 75}px`;
            heroMargin = ($el.outerHeight() - 55) + 20;
          }
          $hero.addClass('hero--cta-icon');
        }
        $blurb.css({ bottom: blurbBottom });
        $hero.find('.img').css({ marginBottom: heroMargin });
      }
    }
    adjustCtaIcons();
    $(window).on('resize', function() {
      console.warn('resize');
      adjustCtaIcons();
    });
  }
}

DrupalBehavior.register('psh_theme.components', 'icon-cta', IconCta);
